import { useQuery } from '@tanstack/react-query';
import { WIDGET } from '../../constants/queryKeys';
import WidgetApiV2 from '../../lib/api/widget/WidgetApiV2';
import {
  BannerWidgetDetailV2,
  BrandWidgetDetailV2,
  EventWidgetDetailV2,
  ProductWidgetDetailV2,
  TimedealWidgetDetailV2,
  WIDGET_TYPE_V2,
} from '../../types/widget';

type UseWidgetDetailReturnType = {
  data?:
    | BannerWidgetDetailV2
    | BrandWidgetDetailV2
    | EventWidgetDetailV2
    | ProductWidgetDetailV2
    | TimedealWidgetDetailV2;
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
};

const useWidgetDetail = (id: number): UseWidgetDetailReturnType => {
  const { data, isLoading, isSuccess, isError } = useQuery(
    [...WIDGET.DETAIL, id],
    () => WidgetApiV2.getWidgetDetail(id),
    {
      enabled: !!id,
      cacheTime: 0,
      select: (res) => {
        if (res.widget.type === WIDGET_TYPE_V2.PRODUCT) return new ProductWidgetDetailV2(res.widget);
        if (res.widget.type === WIDGET_TYPE_V2.BRAND) return new BrandWidgetDetailV2(res.widget);
        if (res.widget.type === WIDGET_TYPE_V2.EVENT) return new EventWidgetDetailV2(res.widget);
        if (res.widget.type === WIDGET_TYPE_V2.BANNER) return new BannerWidgetDetailV2(res.widget);
        if (res.widget.type === WIDGET_TYPE_V2.TIMEDEAL) return new TimedealWidgetDetailV2(res.widget);
      },
    },
  );

  return { data, isLoading, isSuccess, isError };
};

export default useWidgetDetail;
